<template>
  <div class="errBox">
    <div class="errHead">
      <span class="errLabel">Error details</span>
      <button class="copyBtn" type="button" @click="copy">{{ copied ? 'Copied' : 'Copy' }}</button>
    </div>
    <pre class="errText">{{ detail }}</pre>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'

const props = defineProps<{ detail: string }>()
const copied = ref(false)

async function copy(): Promise<void> {
  try {
    await navigator.clipboard.writeText(props.detail)
    copied.value = true
    setTimeout(() => (copied.value = false), 1500)
  } catch {
    /* clipboard may be unavailable */
  }
}
</script>

<style scoped>
.errBox { border: 1px solid var(--color-border-strong); border-radius: var(--radius-md); background: var(--color-bg-subtle); overflow: hidden; text-align: left; }
.errHead { display: flex; align-items: center; justify-content: space-between; padding: var(--space-2) var(--space-3); border-bottom: 1px solid var(--color-border-subtle); }
.errLabel { font-size: var(--fs-xs); font-weight: var(--fw-semibold); letter-spacing: var(--tracking-wide); text-transform: uppercase; color: var(--color-text-tertiary); }
.copyBtn { border: 0; background: transparent; cursor: pointer; font-size: var(--fs-xs); font-weight: var(--fw-medium); color: var(--color-text-secondary); padding: 2px 6px; border-radius: var(--radius-sm); }
.copyBtn:hover { color: var(--color-text-primary); background: var(--color-bg-surface); }
.errText { margin: 0; padding: var(--space-3); font-family: var(--font-mono); font-size: var(--fs-xs); line-height: var(--lh-normal); color: var(--color-text-primary); white-space: pre-wrap; word-break: break-word; }
</style>
